import i18n from "../i18n";
import { properPrice } from "./price";

export function discountCodeDisclaimer(discountCode, currencies) {
    const { discount } = discountCode;
    const discountValue = discount.type === "percent" ? `${discount.value} %` : properPrice(discount.value, discount.currency, currencies);
    return `${i18n.t(`shared.discountCode.thanksToThisCode`, { code: discountCode.code })} ${i18n.t(`shared.discountCode.on.${discount.on}`)} ${i18n.t(`shared.discountCode.isReducedOf`)} ${discountValue}.`;
}